import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { absencesContext } from './AbsencesContext';
import { appUserContext } from "helpers/services";


let WorkLogs = () => {
    let service = useContext(absencesContext);
    let appUserService = useContext(appUserContext);


    return (
        <>
            <PageHeader
                pageTitle={"Assenze"}
                addNewUrl={appUserService.currentUser?.simecClaims?.canEditScheduling === true ? `/absence/addnew/` :  undefined}
            />

            <Filter />

            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default WorkLogs;